<template>
  <div class="etms-router-body">
    <div>
      <table>
        <tr>
          <td class="header-top-td">
            <el-select size="mini" placeholder="单号分类" v-model="search.oddtype" filterable class="header-odd-category fl">
              <el-option v-for="item in oddtypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </td>
          <td rowspan="2">
            <el-input size="mini" type="textarea" :rows="3" placeholder="请输入单号" v-model="search.odd" class="el-width-200 fl"></el-input>
          </td>
          <td style="line-height:30px;">
            <span class="fl">发货商：</span>
            <el-select size="mini" placeholder="请选择发货商" v-model="search.shippers" filterable clearable class="el-width-200 fl"></el-select>
            <span class="fl">渠道：</span>
            <el-select size="mini" placeholder="请选择运输渠道" v-model="search.channel" filterable clearable class="el-width-200 fl"></el-select>
            <span class="fl">目的国家：</span>
            <el-select size="mini" placeholder="请选择目的国家" v-model="search.purposeregion" filterable clearable class="el-width-200 fl"></el-select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <el-select size="mini" placeholder="时间分类" v-model="search.waybilltimetype" filterable class="el-width-100 fl">
              <el-option v-for="item in waybilltimetypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
            <el-date-picker size="mini" v-model="search.timeslot" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" class="el-width-300 fl">
            </el-date-picker>
            <el-button size="mini" type="primary" icon="el-icon-download" class="fr">下载</el-button>
            <el-button size="mini" type="primary" icon="el-icon-search" class="el-btn-margin fr">搜索</el-button>
          </td>
        </tr>
      </table>
    </div>
    <div class="div-list">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageindex" :page-sizes="pagesizes" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="recordcount"></el-pagination>
      <el-table :data="waybillfeelist" :border="true" class="etms-router-list">
        <el-table-column label="客户单号" align="center" prop="CustomerOdd"></el-table-column>
        <el-table-column label="追踪单号" align="center" prop="TrackOdd"></el-table-column>
        <el-table-column label="发货商" align="center" prop="TargetEnterpriseName"></el-table-column>
        <el-table-column label="渠道" align="center" prop="ChannelName"></el-table-column>
        <el-table-column label="目的国家" align="center" prop="PurposeRegion"></el-table-column>
        <el-table-column label="创建时间" align="center" prop="FirstEditTime"></el-table-column>
        <el-table-column label="入库时间" align="center" prop="PutStorageTime"></el-table-column>
        <el-table-column label="入库重量" align="center" prop="PutStorageTotalWeight"></el-table-column>
        <el-table-column label="入库体积" align="center" prop="PutStorageTotalVolume"></el-table-column>
        <el-table-column label="入库体积重" align="center" prop="PutStorageTotalVolumeWeight"></el-table-column>
        <el-table-column label="总费用" align="center" prop="TotalFee"></el-table-column>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <table border="0" class="waybill-fee-table" cellpadding="0" cellspacing="0">
              <tr>
                <th>费用类型</th>
                <th>标准价</th>
                <th>折扣价</th>
                <th>计费值</th>
                <th>计费公示</th>
                <th>备注</th>
              </tr>
              <tr v-for="item in scope.row.WaybillFees" :key="item.WaybillFeeId">
                <td>{{item.WaybillFeeType}}</td>
                <td>{{item.StandardFee}}</td>
                <td>{{item.DiscountFee}}</td>
                <td>{{item.BillingValue}}</td>
                <td>{{item.BillingFormulaString}}</td>
                <td>{{item.BillingFormulaNote}}</td>
              </tr>
            </table>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      oddtypes: this.constant.oddtypes,
      waybilltimetypes: this.constant.waybilltimetypes,
      pagesizes: this.constant.pagesizes,
      pageindex: 1,
      pagesize: 100,
      recordcount: 0,
      pickerOptions: this.constant.pickerOptions,
      search: {
        shippers: '',
        channel: '',
        purposeregion: '',
        purposeair: '',
        purposeport: '',
        purposedepot: '',
        waybilltimetype: 'firstedittime',
        timeslot: [],
        oddtype: 'serviceodd',
        odd: ''
      },
      waybillfeelist: [
        {
          WaybillId: '',
          CustomerOdd: '64821656232',
          TrackOdd: 'RC1225623261CN',
          TargetEnterpriseName: '广州凯捷物流供应链',
          ChannelName: '广州小包',
          PurposeRegion: '美国',
          FirstEditTime: '2018-08-10',
          PutStorageTime: '2018-08-11',
          PutStorageTotalWeight: '1.52',
          PutStorageTotalVolume: '0',
          PutStorageTotalVolumeWeight: '0',
          TotalFee: '52',
          WaybillFees: [
            {
              WaybillFeeId: '0',
              WaybillFeeType: '运费',
              StandardFee: '45',
              DiscountFee: '42',
              BillingValue: '1.52',
              BillingFormulaString: '(28.1954*1.52)*0.98',
              BillingFormulaNote: '不足1KG按1KG算'
            },
            {
              WaybillFeeId: '1',
              WaybillFeeType: '挂号费',
              StandardFee: '10',
              DiscountFee: '10',
              BillingValue: '1.52',
              BillingFormulaString: '10',
              BillingFormulaNote: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange (val) { },
    handleCurrentChange (val) { },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.header-odd-category {
  top: 1px;
  position: absolute;
}

.header-top-td {
  position: relative;
  width: 120px;
}

.el-btn-margin {
  margin-right: 10px;
}

.etms-router-list .waybill-fee-table {
  border: 0px;
  width: 100%;
  margin: 0;
  padding: 0;
}

.etms-router-list .waybill-fee-table th,
.etms-router-list .waybill-fee-table td {
  padding-left: 20px;
  line-height: 20px;
}

.etms-router-list .el-table__expanded-cell[class*="cell"] {
  padding: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/ctms/waybill_fee_details.vue